<template>
  <side-base>
    <div class="swrap">
      <vx-list class="smain" enable :api="api" :params="params" @load="onLoad" ref="vxlist">
        <div class="slist">
          <div
            class="sitem van-hairline--bottom"
            v-for="item in listAll"
            :key="item.id"
            @click="clickHandler(item)"
          >
            <div class="l sicon">
              <side-icon-select :checked="ids.includes(item.id)" />
            </div>
            <div class="r">
              <div class="rln1">{{ item.title }}</div>
              <div class="rln2">
                {{ item.questions.map(item => item.title).join('、') }}
              </div>
            </div>
          </div>
        </div>
        <van-empty v-if="listAll.length === 0 && !loading" description="还没有回评问卷~">
          <van-button type="primary" square round @click="toAdd">新增回评问卷</van-button>
        </van-empty>
        <div class="desc">
          没找到合适的回评问卷？<span class="link" @click="$router.push('/comment-reply-list')"
            >更多回评问卷</span
          >
        </div>
      </vx-list>
      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      />
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-comment-reply',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '回评问卷选择',
      // 是否正在加载数据
      loading: true,
      api: this.$api.getQanda,
      params: {},
      // 过滤等配置
      config: {},
    };
  },
  methods: {
    // 数据加载
    onLoad(list, res) {
      this.listAll = list;
      this.total = res.page.totalCount;
      this.loading = false;
    },
    toAdd() {
      this.$router.push('/comment-reply-add');
    },
  },
  created() {
    this.$onBus('refresh-comment-reply-list', () => {
      this.showLoading();
      this.$refs.vxlist.refresh();
    });
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        display: flex;
        padding: calc(var(--gap) * 12) 0;
        .l.sicon {
          margin-right: calc(var(--gap) * 16);
          padding-top: calc(var(--gap) * 2);
        }
        .r {
          flex: 1;
          .rln1 {
            color: var(--g8);
            font-size: var(--fs-lg);
            line-height: var(--lh-lg);
            font-weight: var(--bold);
          }
          .rln2 {
            margin-top: calc(var(--gap) * 4);
            color: var(--g6);
            font-size: var(--fs-md);
            line-height: var(--lh-md);
          }
        }
      }
    }
    .desc {
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      color: var(--g6);
      margin: calc(var(--gap) * 8) calc(var(--gap) * 16);
      .link {
       color: var(--tlc);
      }
    }
  }
}
</style>